<template>
    <v-app v-bind:class="{ active: isActive }">

        <v-card
            class=" overflow-hidden"
            height="100%"
            tile
        >

            <v-app-bar
                color="blue-grey lighten-5"
            >
                <v-app-bar-nav-icon @click="drawer = true"></v-app-bar-nav-icon>

                <v-toolbar-title v-bind:class="{ active: isActive }">
                    МЕНЮ
                </v-toolbar-title>

                <v-spacer></v-spacer>





                <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                    <template v-slot:activator="{ on }">
                        <v-btn color="indigo" dark v-on="on">Настройки</v-btn>
                    </template>

                    <v-card tile>
                        <v-toolbar dark color="indigo">
                            <v-btn icon dark @click="dialog = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>

                            <v-toolbar-title>Настройки</v-toolbar-title>
                            <v-spacer></v-spacer>

                            <v-toolbar-items>
                                <v-btn dark text @click="saveSettings">Сохранить</v-btn>
                            </v-toolbar-items>
                        </v-toolbar>

                        <v-divider></v-divider>

                        <v-list three-line subheader>
                            <v-subheader>Общие настройки</v-subheader>

                            <v-list-item>
                                <v-list-item-action>
                                    <v-checkbox v-model="notifications"></v-checkbox>
                                </v-list-item-action>

                                <v-list-item-content>
                                    <v-list-item-title>Версия для слабовидящих</v-list-item-title>
                                    <v-list-item-subtitle>После активации, нажмите сохранить</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>

                        </v-list>
                    </v-card>
                </v-dialog>

            </v-app-bar>

            <v-navigation-drawer
                v-bind:class="{ active: isActive }"
                v-model="drawer"
                absolute
                temporary
                :width="600"
            >


                <v-list>
                    <v-list-item>
                        <v-list-item-title>+ Главная</v-list-item-title>
                    </v-list-item>




                        <v-list-group
                            no-action
                        >

                            <template v-slot:activator>
                                <v-list-item-content>
                                <v-list-item-title>+ Одно окно</v-list-item-title>
                                </v-list-item-content>
                            </template>

                            <v-list-item
                                v-for="(admin, i) in admins"
                                :key="i"
                                link
                            >
                                <v-list-item-title v-text="admin[0]"></v-list-item-title>
                            </v-list-item>

                        </v-list-group>

                        <v-list-group
                            no-action
                        >
                            <template v-slot:activator>
                                <v-list-item-content>
                                    <v-list-item-title>+ О центре</v-list-item-title>
                                </v-list-item-content>
                            </template>

                            <v-list-item
                                v-for="(crud, i) in cruds"
                                :key="i"
                            >

                                <v-list-item-title v-text="crud[0]"></v-list-item-title>
                            </v-list-item>
                        </v-list-group>


                    <v-list-item>
                        <v-list-item-title>+ Диагностическая работа</v-list-item-title>
                    </v-list-item>

                    <v-list-group
                        no-action
                    >
                        <template v-slot:activator>
                            <v-list-item-content>
                                <v-list-item-title>+ Для вас, педагоги</v-list-item-title>
                            </v-list-item-content>
                        </template>

                        <v-list-item
                            v-for="(cruds, i) in forYouTeachers"
                            :key="i"
                        >

                            <v-list-item-title v-text="cruds[0]"></v-list-item-title>
                        </v-list-item>
                    </v-list-group>

                    <!--FOR PARENTS-->
                    <v-list-group
                        no-action
                    >
                        <template v-slot:activator>
                            <v-list-item-content>
                                <v-list-item-title>+ Для вас, родители</v-list-item-title>
                            </v-list-item-content>
                        </template>

                        <v-list-item
                            v-for="(fyp, i) in forYouParents"
                            :key="i"
                        >

                            <v-list-item-title v-text="fyp[0]"></v-list-item-title>
                        </v-list-item>
                    </v-list-group>

                    <v-list-item>
                        <v-list-item-title>+ Странички нашей жизни</v-list-item-title>
                    </v-list-item>

                    <!--SERVICES-->
                    <v-list-group
                        no-action
                    >
                        <template v-slot:activator>
                            <v-list-item-content>
                                <v-list-item-title>+ Сервисы</v-list-item-title>
                            </v-list-item-content>
                        </template>

                        <v-list-item
                            v-for="(srvs, i) in services"
                            :key="i"
                        >

                            <v-list-item-title v-text="srvs[0]"></v-list-item-title>
                        </v-list-item>
                    </v-list-group>

                    <v-list-item>
                        <v-list-item-title>+ Инклюзивное образование</v-list-item-title>
                    </v-list-item>

                    <!--SPPS-->
                    <v-list-group
                        no-action
                    >
                        <template v-slot:activator>
                            <v-list-item-content>
                                <v-list-item-title>+ Социально-педагогическая и психологическая служба</v-list-item-title>
                            </v-list-item-content>
                        </template>

                        <v-list-item
                            v-for="(spaps, i) in SocioPedagogicalAndPsychologicalService"
                            :key="i"
                        >

                            <v-list-item-title v-text="spaps[0]"></v-list-item-title>
                        </v-list-item>
                    </v-list-group>

                    <v-list-item>
                        <v-list-item-title>+ Архив новостей</v-list-item-title>
                    </v-list-item>

                    <v-list-item>
                        <v-list-item-title>+ Ранняя комплексная помощь</v-list-item-title>
                    </v-list-item>

                    <v-list-item>
                        <v-list-item-title>+ Уголок безопасности</v-list-item-title>
                    </v-list-item>

                    <v-list-item>
                        <v-list-item-title>+ Бобруйск гостеприимный</v-list-item-title>
                    </v-list-item>
                </v-list>

            </v-navigation-drawer>

            <v-container>
                
                <v-row>
                    <v-col cols="12" md="12">
                        <p class="subtitle-2 text-center">
                            Министерство образования Республики Беларусь
                            <br>
                            Управление по образованию Бобруйского горисполкома
                        </p>

                        <p class="headline text-center">
                            Государственное учреждение образования <br>
                            «‎Центр коррекционно-развивающего обучения и реабилитации г. Бобруйска‎‎»
                        </p>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col
                        cols="12"
                        md="3"
                    >
                        
                        <LeftSideBar />

                    </v-col>

                    <v-col
                        cols="12"
                        md="9"
                    >

                        <router-view></router-view>

                    </v-col>

                </v-row>


            </v-container>


            <Footer />

        </v-card>
    </v-app>
</template>

<script>
    import LeftSideBar from './components/LeftSideBar.vue'
    import Footer from './components/Footer.vue'
    export default {
        name: 'App',

        components: {
            LeftSideBar, Footer
        },

        data: () => ({

            isActive: false,

            activeColor: 'black',
            fontSize: 2,

            dialog: false,
            notifications: false,
            sound: true,
            widgets: false,

            drawer: false,
            item: 0,
            items: [
                { text: 'Одно окно' },
                { text: 'О центре' },
                { text: 'Диагностическая работа' },
                { text: 'Для вас, педагоги' },
                { text: 'Для вас, родители' },
                { text: 'Странички нашей жизни' },
                { text: 'Сервисы' },
                { text: 'Инклюзивное образование, родители' },
                { text: 'Социально-педагогическая и психологическая служба' },
                { text: 'Архив новостей' },
                { text: 'Ранняя комплексная помощь' },
                { text: 'Уголок безопасности', },
                { text: 'Бобруйск гостепреимный', },
            ],

            admins: [
                ['Администрация центра'],
                ['График работы администрации'],
                ['График приёма граждан'],
                ['График Административные процедуры'],
                ['Образцы заявлений'],
                ['Электронное обращение'],
                ['Правила подачи электронного обращения'],
                ['Телефоны «горячих линий»'],
                ['Вышестоящие организации'],
            ],

            cruds: [
                ['Цели и задачи'],
                ['Документы'],
                ['График «прямых» телефонных линий'],
                ['Как нас найти'],
                ['Нормативные правовые документы'],
            ],

            forYouTeachers: [
                ['МО-планы работы 2019/2020 учебный год', 'add'],
            ],

            forYouParents: [
                ['Литературная страничка', 'add'],
            ],

            services: [
                ['Архив новостей'],
                ['Карта сайта'],
            ],

            SocioPedagogicalAndPsychologicalService: [
                ['Профилактика насилия в семье'],
            ],

        }),

        mounted() {

            if(localStorage.notifications) {
                this.notifications = localStorage.notifications;
            }
            
        },

        watch: {
            
            notifications(newName) {
                localStorage.notifications = newName;
                console.log(localStorage.notifications)

                if(localStorage.notifications == "false" || localStorage.notifications == undefined) {
                    localStorage.clear()
                    this.isActive = false

                } else {
                    this.notifications = localStorage.notifications;
                    this.isActive = true

                }


            }

        },

        methods: {
            saveSettings() {
                this.dialog = false;

                if(!this.notifications) {
                    localStorage.clear()
                } else {
                    localStorage.notifications = this.notifications;
                }
                
            }
        }
};
</script>

<style lang="scss" scoped>
    .active {
        font-size: 1.3rem !important;
        font-weight: bold !important;
        color: #000 !important;
        text-transform: uppercase;
    }
</style>